import { Component, Inject } from '@angular/core';

import { VideogularComponent } from '../Videogular.Component';

import { VBRICK_PLAYER_HOST } from '../../VbPlayerHostToken';

/**
 * Component to switch between fullscreen and normal mode.
 *
 * <pre>
 * <videogular>
 *    <vg-media></vg-media>
 *
 *    <vg-controls>
 *        <vg-fullscreen-button></vg-fullscreen-button>
 *    </vg-controls>
 * </videogular>
 * </pre>
 *
 */
@Component({
	selector: 'vg-fullscreen-button',
	template: `
		<button
			type="button"
			[attr.aria-label]="vgApi.isFullScreen ? vbrickPlayer.translations.fullScreenEnd : vbrickPlayer.translations.fullScreenStart"
			[attr.aria-pressed]="!!vgApi.isFullScreen"
			[tooltip]="vgApi.isFullScreen ? vbrickPlayer.translations.fullScreenEnd : vbrickPlayer.translations.fullScreenStart"
			[placement]="'left'"
			[ngClass]="[
				'button',
				'vb-icon',
				vgApi.isFullScreen ? 'vb-icon-fullscreen-exit' : 'vb-icon-fullscreen-enter'
			]"
			vbControlBarFocus
			(click)="vgApi.toggleFullScreen()">
		</button>
	`,
	standalone: false,
	styleUrls: ['./VgFullscreenButton.Component.ng.less']
})
export class VgFullscreenButtonComponent {
	constructor(
		@Inject(VBRICK_PLAYER_HOST)
		public vbrickPlayer: any,
		public vgApi: VideogularComponent
	) {}
}
